import { makeAutoObservable } from "mobx";
import { userService } from "./UserService";
import { toastMsg } from "../../utilities/helpers/ToastHelper";
import uploadHelper from "../../utilities/helpers/ImageUploader";
import returnValidFileNameSupabase from "../../utilities/helpers/ReturnValidFileNameSupabase";

class UserState{
    constructor(){
        makeAutoObservable(this)
    }
    tempImg: string |null = '';
    loadingDataStatus: boolean = true;
    updatingStatus: boolean = false;
    isAvatarChanged: boolean = false;
    imgFile: any
    userInfo: {username: string, full_name: string, gender: number, img: string, email: string, phone_number: string, location: string}={
        username: '',
        full_name: '',
        gender: 1,
        img: '',
        email: '',
        phone_number: '',
        location: '',
    }
    async updatingUserInfo(data:any){
        this.userInfo.email = data.email;
        this.userInfo.full_name = data.full_name;
        this.userInfo.location = data.location;
        this.userInfo.phone_number = data.phone_number;
        this.userInfo.username = data.username;
        this.userInfo.gender = Number(data.gender);
        this.userInfo.img = (this.isAvatarChanged ? await this.handleUploadFile() : this.userInfo.img)
        this.updatingStatus = true;
        const response = await userService.updatingUser(this.userInfo);
        if(response?.error){
            toastMsg.error('Đã có lỗi xảy ra!', 'error')
        }
        else{
            toastMsg.success('Cập nhật thông tin thành công!', 'success')
        }
        this.updatingStatus = false;
    }
    async gettingUserInfo(){
        this.loadingDataStatus = true;
        const responseData = await userService.gettingUser();
        this.loadingDataStatus = false;
        this.userInfo.email = responseData?.data.email;
        this.userInfo.full_name = responseData?.data.full_name;
        this.userInfo.location = responseData?.data.location;
        this.userInfo.phone_number = responseData?.data.phone_number;
        this.userInfo.username = responseData?.data.username;
        this.userInfo.gender = responseData?.data.gender;
        this.userInfo.img = responseData?.data.img;
    }
    handleCreateTemporaryImg(event:any){
        const tempFile = URL.createObjectURL(event)
        this.userInfo.img = tempFile;
        this.imgFile = event;
        this.isAvatarChanged = true;
    }
    async handleUploadFile(){
        const {data, error} = await uploadHelper(this.imgFile, 'avatar');
        if(error){
            toastMsg.error('Đã có lỗi xảy ra khi upload ảnh', ''); return '';
        }
        else{
            return returnValidFileNameSupabase(data.fullPath)
        }
    }
}
export const userState = new UserState();